module.exports = __webpack_public_path__ + "static/media/blue-transition-interreg-ns-vertical.c9190c1c.png";